import { QueryClient } from "@tanstack/react-query";

const MAX_CLIENT_QUERY_RETRIES = 2;
const MAX_SERVER_QUERY_RETRIES = 1;

function shouldRetryQuery(failureCount: number): boolean {
  const maxRetries =
    typeof window === "undefined" ? MAX_SERVER_QUERY_RETRIES : MAX_CLIENT_QUERY_RETRIES;
  return failureCount < maxRetries;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetryQuery,
        // Avoid in-place data changes while users are actively viewing a page.
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        // Preserve refetch-on-remount so navigating away and back refreshes stale data.
        refetchOnMount: true,
      },
    },
  });
}

let clientQueryClient: QueryClient | null = null;
export function getClientsideQueryClient(): QueryClient {
  if (typeof window === "undefined") {
    throw new Error("getClientsideQueryClient should only be called on the client");
  }
  if (!clientQueryClient) {
    clientQueryClient = createQueryClient();
  }
  return clientQueryClient;
}
